import React from 'react'
import Wrapper from './style'

const SchTabItem = ({ children, selected, onClick}) => {
	return (
		<Wrapper
			className={
				"link-item"
				+ (selected ? " selected" : "")
			}
			onClick={onClick}
		>
			{children}
		</Wrapper>
	)
}

export default SchTabItem
